
export const retryNetwork = async (fn, ...args) => {
    const retryCount = 3
    for (let i = 0; i < retryCount; i++) {
        try {
            return await fn(...args);
        } catch (e) {
            if (i !== retryCount - 1 && e.message === "Network Error") {
                console.log("Retry async error", e);
                continue
            }
            throw e
        }
    }
}